export const DB_COLLECTION = {
    TIME_SLOT: "timeslot",
    CATEGORY: "category",
    APPOINTMENT: "appointmentdata",
    BOOKING: "booking",
    ACCEPTAPPOINTMENT: "acceptedappointment",
    BOOKED: "booked",
    AUTH: "auth"

}